import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("product", ["product"]),
    scopes() {
      return [
        {
          color: "#A900A3",
          options: [
            {
              icon: "fa-regular fa-list",
              title: "Informações básicas",
              subtitle: "Escolha o tipo do produto e informações básicas",
              route: "product-basic-info"
            },
            {
              icon: "fa-regular fa-handshake",
              title: "Coprodutores",
              subtitle: "Compartilhe o produto com seus coprodutores",
              route: "product-coproducers"
            }
          ]
        },
        {
          color: "#0693FF",
          options: [
            {
              icon: "fa-regular fa-shield-check",
              title: "Fazer check-in",
              subtitle:
                "Faça o check-in dos seus participantes através da leitura do QR Code",
              modal: "checkin",
              type_product: ["onsite_event"],
              permissions: ["gerenciar-participantes"]
            },
            {
              icon: "fa-regular fa-ticket-perforated",
              title: "Ingressos",
              subtitle: "Visualize e configure os ingressos do seu evento",
              route: "event-lots",
              type_product: ["onsite_event"]
            },
            {
              icon: "fa-regular fa-users",
              title: "Participantes",
              subtitle: "Lista de participantes e controle de check-in",
              route: "event-participants",
              type_product: ["onsite_event"],
              permissions: ["gerenciar-participantes"]
            },
            {
              icon: "fa-regular fa-file-invoice-dollar",
              title: "Configurar Checkout",
              subtitle: "Configure as informações do seu checkout",
              route: "product-checkout",
              // warning: "Para aprovação do seu produto configure o checkout.",
              permissions: ["configurar-checkout"]
            },
            {
              icon: "fa-regular fa-wand-magic-sparkles",
              title: "Personalizar Checkout",
              subtitle:
                "Defina como vai ser a cara do seu checkout, para melhor atender seu clientes",
              route: "product-customize-checkout",
              // warning: "Para aprovação do seu produto configure o checkout.",
              permissions: ["configurar-checkout"]
            },
            {
              icon: "fa-regular fa-link",
              title: "Links de Divulgação",
              subtitle: "Veja os links gerados para divulgação do seu produto",
              route: "product-links"
            },
            {
              icon: "fa-regular fa-dollar-sign",
              title: "Precificação e Ofertas",
              subtitle: "Configure os preços e ofertas de venda do seu produto",
              route: "product-prices",
              permissions: ["gerenciar-ofertas"],
              type_product: ["online_course"]
            },
            {
              icon: "fa-regular fa-dollar-sign",
              title: "Precificação e Planos",
              subtitle: "Configure os preços e planos de venda do seu produto",
              route: "product-plans",
              permissions: ["gerenciar-ofertas"],
              type_product: ["signature"]
            },
            {
              icon: "fa-regular fa-ticket",
              title: "Cupons de desconto",
              subtitle:
                "Visualize e configure os cupons de desconto do seu produto",
              route: "product-coupons",
              permissions: ["gerenciar-ofertas"],
              type_product: ["online_course"]
            },
            {
              icon: "fa-regular fa-filter-circle-dollar",
              title: "Funil de vendas",
              subtitle: "Ofereça um novo produto após a primeira compra",
              route: "product-upsell",
              type_product: ["online_course", "signature"]
            },
            {
              icon: "fa-regular fa-bullseye-pointer",
              title: "Link one click buy",
              subtitle:
                "Ofereça um produto após a primeira compra, usando um link one click buy",
              route: "product-oneclickbuy"
            },
            {
              icon: "fa-regular fa-crosshairs",
              title: "Pixel de rastreamento",
              subtitle:
                "Monitore o comportamento dos seus compradores e anúncios",
              route: "product-edit-pixel"
            },
            {
              icon: "fa-regular fa-display-chart-up-circle-dollar",
              title: "Api de conversões",
              subtitle:
                "Otimize suas campanhas e anúncios com informações sobre o comportamento de seu cliente",
              route: "product-analytics"
            }
          ]
        },
        {
          color: "#008C91",
          options: [
            {
              icon: "fa-regular fa-fill-drip",
              title: "Configurar área de Membros",
              subtitle:
                "Configure o layout da sua área de membros, Certificado, Suporte e FAQ",
              route: "product-member-area-setup",
              type_product: ["online_course", "signature"]
            },
            {
              icon: "fa-regular fa-book",
              title: "Conteúdo",
              subtitle:
                "Adicione e organize o conteúdo que será disponibilizado para seus clientes",
              route: "product-member-area-modules",
              type_product: ["online_course", "signature"]
            },
            {
              icon: "fa-regular fa-tag",
              title: "Categorias",
              subtitle:
                "Personalize uma categoria para agrupar os módulos de um mesmo tópico",
              route: "product-member-area-categories",
              type_product: ["online_course", "signature"]
            },
            {
              icon: "fa-regular fa-user-graduate",
              title: "Alunos",
              subtitle: "Adicione e acompanhe o progresso dos seus alunos",
              route: "product-member-area-students",
              type_product: ["online_course", "signature"],
              status: ["active", "inactive"]
            },
            {
              icon: "fa-regular fa-users",
              title: "Turmas",
              subtitle: "Organize seus alunos em turmas",
              route: "product-member-area-groups",
              type_product: ["online_course", "signature"],
              status: ["active", "inactive"]
            },
            {
              icon: "fa-regular fa-comment",
              title: "Comentários",
              subtitle: "Visualize os comentários da sua área de membros",
              route: "product-member-area-comments",
              type_product: ["online_course", "signature"],
              status: ["active", "inactive"]
            }
          ]
        }
      ]
        .map(scope => ({
          ...scope,
          options: scope.options.filter(opt => {
            if (
              opt.type_product &&
              !opt.type_product.includes(this.product.type_product)
            )
              return false;

            if (
              opt.permissions &&
              opt.permissions.find(p => !this.$permissions.hasPermission(p))
            )
              return false;

            if (opt.status && !opt.status.includes(this.product.status))
              return false;

            return true;
          })
        }))
        .filter(scope => !!scope.options.length);
    }
  }
};
